import { Renderer2 } from '@angular/core';
import { IApplicationService } from '@pit/core';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';

export enum AppMode {

    Guest = 1,
    User = 2,
    Admin = 4

}

export interface IPinItTrackFrontendApplicationService extends IApplicationService {

    appMode?: AppMode;
    isLoading?: boolean;
    isLoading$?: Observable<boolean>;

    breadcrumbItems$?: Observable<MenuItem[]>;
    activeTopbarItem?: string;
    isInlineMenuActive?: any;
    isMenuActive?: boolean;
    isMenuHoverActive?: boolean;
    isMobileMenuActive?: boolean;
    isMobileTopbarActive?: boolean;
    isRightMenuActive?: boolean;
    layoutMode?: string;
    menuMode?: string;
    publthemeMenu?: string;
    themeMenu?: string;
    themeTopbar?: string;
    inlineMenuPosition?: string;
    inputStyle?: string;
    menuSource$?: Observable<string>
    resetSource$?: Observable<unknown>;
    topBarMenuItems?: any[];
    sidebarMenuItems?: any[];

    isDesktop?: boolean;
    isMobile?: boolean;
    isSidebarOverlay?: boolean;
    isSidebarSlim?: boolean;
    isSidebarStatic?: boolean;

    resetMenu(): void;
    setBreadcrumbItems(items: MenuItem[]): void;
    setRenderer(document: Document, renderer: Renderer2): void;

    onInlineMenuClick(event: any, key: any): void;
    onMenuClick($event: any): void;
    onMenuButtonClick(event: any): void;
    onMenuStateChange(key: string): void;
    onRightMenuButtonClick(event: any): void;
    onTopbarItemClick(event: any, item: any): void;
    onTopbarMobileButtonClick(event: any): void;
    onTopbarSubItemClick(event: any): void;

}
